import React from 'react';

const connectionContext = React.createContext();

export default connectionContext;